import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { CITY_PATH } from '../../../../config/paths';

const EditCityButton = ({ cityId }) => (
  <Link className="btn btn-primary" to={`${CITY_PATH}/${cityId}/edit`}>
    Editar
  </Link>
);

EditCityButton.propTypes = {
    cityId: PropTypes.number.isRequired,
};

export default EditCityButton;